import api from './http';
import axios from 'axios';

// Adhesion kits
export const getAdhesionSettings = () => api.get('/adhesion/settings');
export const listOfficialAdhesionKits = () => api.get('/adhesion/official-kits');
export const uploadOfficialAdhesionKit = (kitType, file, versionComment = '') => {
  const data = new FormData();
  data.append('file', file);
  data.append('version_comment', versionComment.trim());
  return api.post(`/adhesion/official-kits/${kitType}`, data, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const downloadOfficialAdhesionKit = (versionId, download = false) =>
  api.get(`/adhesion/official-kits/${versionId}/pdf`, { params: { download }, responseType: 'blob' });
export const updateAdhesionSettings = (data) => api.patch('/adhesion/settings', data);
export const sendAdhesionKit = (data) => api.post('/adhesion/send', data);
export const listAdhesionKits = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return api.get(`/adhesion/kits${qs ? `?${qs}` : ''}`);
};
export const getAdhesionKit = (id) => api.get(`/adhesion/kits/${id}`);
export const updateAdhesionKit = (id, data) => api.patch(`/adhesion/kits/${id}`, data);
export const downloadAdhesionKitPdf = (token, download = true) => axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/portal/adhesion/${encodeURIComponent(token)}/kit-pdf`, { params: { download }, responseType: 'blob' });
export const getAdminAdhesionKitPdf = (id, download = false) => api.get(`/adhesion/kits/${id}/pdf`, { params: { download }, responseType: 'blob' });
export const resendAdhesionKit = (id) => api.post(`/adhesion/kits/${id}/resend`);
export const checkAdhesionKitEmail = (id) => api.post(`/adhesion/kits/${id}/email-status`);
export const markAdhesionPaidBank = (id) => api.post(`/adhesion/kits/${id}/mark-paid-bank`);
export const downloadAdhesionReceipt = (id) => api.get(`/adhesion/kits/${id}/receipt`, { responseType: 'blob' });
export const getAdhesionKpis = () => api.get('/adhesion/kpis');
export const uploadKitAttachments = (kitId, files) => {
  const fd = new FormData();
  for (const f of files) fd.append('files', f);
  return api.post(`/adhesion/kits/${kitId}/attachments`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const deleteKitAttachment = (kitId, attId) => api.delete(`/adhesion/kits/${kitId}/attachments/${attId}`);

export const patchKitStatus = (kitId, status) => api.patch(`/adhesion/kits/${kitId}/status`, { status });
export const toggleKitReminders = (kitId) => api.patch(`/adhesion/kits/${kitId}/toggle-reminders`);
export const bulkPatchKitsStatus = (kitIds, status) => api.patch('/adhesion/kits/bulk-status', { kit_ids: kitIds, status });
export const getPortalTimeline = (token) => axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/portal/adhesion/${encodeURIComponent(token)}/timeline`);
export const getRemindersStats = () => api.get('/adhesion/reminders/stats');
export const sendManualReminder = (kitId) => api.post(`/adhesion/kits/${kitId}/send-reminder`);
export const downloadRegistry = () => api.get('/adhesion/registry', { responseType: 'blob' });
export const getAdhesionKanban = () => api.get('/adhesion/kanban');
export const runPaymentReminders = () => api.post('/crons/adhesion-payment-reminders');
export const uploadRibPdf = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post('/adhesion/settings/upload-rib', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const getWelcomeTourStatus = () => api.get('/portal/welcome-tour');
export const completeWelcomeTour = () => api.post('/portal/welcome-tour/complete');

// Extensions Session 47
export const getAdhesionCapitalMonthly = () => api.get('/adhesion/capital-monthly');
export const savePortalApplication = (token, application) => api.post(`/portal/adhesion/${token}/save-application`, { application });
export const uploadPortalPiece = (token, kind, file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post(`/portal/adhesion/${token}/upload-piece?kind=${encodeURIComponent(kind)}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const submitPortalApplication = (token, application) => api.post(`/portal/adhesion/${token}/submit-application`, { application });
export const getKitApplication = (kitId) => api.get(`/adhesion/kits/${kitId}/application`);
export const postKitDecision = (kitId, decision) => api.post(`/adhesion/kits/${kitId}/decision`, { decision });
export const getKitCertificate = (kitId) => api.get(`/adhesion/kits/${kitId}/certificate`, { responseType: 'blob' });
export const getCoopDirectory = (q = '') => api.get(`/portal/coop-directory${q ? `?q=${encodeURIComponent(q)}` : ''}`);


// Portal public (sans auth)
export const portalGetAdhesion = (token) => api.get(`/portal/adhesion/${token}`);
export const portalPayAdhesionStripe = (token) => api.post(`/portal/adhesion/${token}/pay-stripe`);
export const portalPayAdhesionBank = (token) => api.post(`/portal/adhesion/${token}/pay-bank`);
export const portalAdhesionKitPdfUrl = (token) =>
  `${process.env.REACT_APP_BACKEND_URL}/api/portal/adhesion/${token}/kit-pdf`;

// Spaces (audiences réutilisables)
export const listSpaces = () => api.get('/spaces');
export const createSpace = (data) => api.post('/spaces', data);
export const updateSpace = (id, data) => api.patch(`/spaces/${id}`, data);
export const deleteSpace = (id) => api.delete(`/spaces/${id}`);

// Publications v2 extensions
export const previewPublication = (data) => api.post('/publications/preview', data, { timeout: 15000 });
export const bulkCreatePublications = (data) => api.post('/publications/bulk', data);
export const cronPublicationsRemindJ3 = () => api.post('/crons/publications-remind-j3');
export const listStaleRecipients = () => api.get('/publications/reminders/stale');
